import { connect } from "react-redux";
import ApprovedAndRejectedList from "./BackModification";
import { bindActionCreators } from "redux";
import { userRequestPendingList, userRequestFilter, csvDownload} from "../../../../services/redux/userHelpdesk/action";

const mapStateToProps = (state) => ({
    approvalPendingRequest : state.UserHelpdesk.approvalPendingRequest,
    filterDetails : state.UserHelpdesk.filterData,
    csvDownloadResponse : state.UserHelpdesk.csvDownloadResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        userRequestPendingList,
        userRequestFilter,
        csvDownload
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ApprovedAndRejectedList);